
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <a><i id="close_confirmation_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>{{title}}</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" *ngIf="bodyParagraphs">
          <p *ngFor="let paragraph of bodyParagraphs" translate [translateParams]="bodyTranslateParams">{{paragraph }}</p>
        </div>
        <div class="col-md-12" *ngIf="nonTranslatableBodyParagraphs">
          <p *ngFor="let paragraph of nonTranslatableBodyParagraphs">{{paragraph }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="confirm_confirmation_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="confirm()" translate>Yes</button>
      <button id="cancel_confirmation_modal_button" type="button" class="btn btn-link cancel" (click)="cancel()" translate>Cancel</button>
    </div>
  